import React from "react";
import classNames from "classnames";

type Props = {
  title: string;
  danger?: boolean;
  confirm?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const FormSubmit = ({ title, danger, confirm, disabled, onClick }: Props) => {
  return (
    <div className="form-group">
      <button
        className={classNames("btn", danger ? "btn-danger" : "btn-success")}
        data-confirm={confirm}
        disabled={disabled}
        onClick={onClick}
      >
        {title}
      </button>
    </div>
  );
};

export default FormSubmit;
